import React, { useEffect, useRef, useState } from "react";
import { BottomBar, ViewApproval, ApprovalStatus, Table, Pagination, Approval, Searchbox, TableSwitch, CardsRenderer, Toast, TableCardRender, Button, Badge, InlineEmployee, CopyValue, ButtonGroup, DateRange } from "../../../../Components";
// import ApprovalFilters from "./filters";
import apis from "../../../../Utils/apis";
import { get } from "../../../../Utils/axios";
import { StampToDate } from "../../../../Utils/utils";
import moment from "moment";
import { FiEye } from "react-icons/fi";
import { useClientSettings } from "Hooks/useClientSettings";

function Pending() {
	const { currency } = useClientSettings();
	const [Status, setStatus] = useState({ label: "Pending", value: "pending" });
	const [OpenId, setOpenId] = useState();
	const [ViewMode, setViewMode] = useState();
	const initial = {
		approvals: [],
		count: 0,
		pages: 0,
	};
	const [Query, setQuery] = useState({
		search: "",
		page: 1,
		dates: {
			startDate: moment().subtract(30, "days").valueOf(),
			endDate: moment().add(30, "days").valueOf(),
		},
	});
	const [Result, setResult] = useState(initial);
	const [Loading, setLoading] = useState(true);
	const listTopRef = useRef(null);
	const totalCount = Number(Result.count) || 0;
	const totalPages = Math.max(1, Number(Result.pages) || 1);
	const currentPage = Math.min(Math.max(Query.page, 1), totalPages);

	useEffect(() => {
		fetchApprovals(Query, Status.value);
	}, [Query, Status]);

	useEffect(() => {
		if (listTopRef.current) {
			listTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}, [Query.page]);

	const fetchApprovals = (query, status) => {
		setLoading(true);
		get(
			`/approval`,
			{
				...query,
				dates: {
					startDate: moment(query.dates.startDate).toDate(),
					endDate: moment(query.dates.endDate).toDate(),
				},
				status,
			},
			(r, e) => {
				if (r) {
					setResult(r);
					setLoading(false);
				} else if (e) {
					Toast.handleError(e);
					setLoading(false);
				}
			}
		);
	};

	return (
		<>
			<div ref={listTopRef} className="p-2 pb-24 sm:p-4">
				<div className="mb-3 rounded-lg border border-surface bg-canvas p-3 text-sm text-secondary">
					Review and act on travel requests submitted to you for approval.
				</div>
				<BottomBar>
					<div className="flex flex-col w-full gap-1.5">
						<div className="flex items-end justify-between gap-2">
							<h5>
								{totalCount} Approval {Status.label}
							</h5>
							<div className="text-xs text-secondary whitespace-nowrap">Page {currentPage} of {totalPages}</div>
						</div>
						<Pagination showNumbers={false} active={currentPage} total={totalPages} onChange={(page) => setQuery({ ...Query, page })} />
					</div>
				</BottomBar>
				<div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
					<div className="w-full overflow-x-auto scrollbar-hidden lg:w-auto">
						<ButtonGroup
							onClick={(status) => {
								setStatus(status);
								setQuery((prev) => ({ ...prev, page: 1 }));
							}}
							size="xs !p-1.5"
							selected={Status}
							className="text-sm whitespace-nowrap min-w-max"
							options={[
								{ label: "Pending", value: "pending" },
								{ label: "Approved", value: "approved" },
								{ label: "Booked", value: "booked" },
								{ label: "Rejected", value: "rejected" },
							]}
						/>
					</div>
					<div className="flex w-full min-w-0 flex-wrap gap-2 lg:w-auto lg:flex-nowrap lg:items-center lg:justify-end">
						<Searchbox className="w-full lg:w-72" placeholder="Search approvals" cmd="s" onChange={(search) => setQuery((prev) => ({ ...prev, search, page: 1 }))} />
						<div className="shrink-0">
							<TableSwitch mode={ViewMode} setMode={setViewMode} />
						</div>
						{Status.value !== "pending" && (
							<DateRange
								backDateSelection={true}
								setRange={(dates) => setQuery((prev) => ({ ...prev, dates, page: 1 }))}
								range={Query.dates}
								className="w-full lg:w-auto"
								inputClass="!p-1.5 !text-xs w-full lg:w-auto"
							/>
						)}
						{/* <ApprovalFilters /> */}
					</div>
				</div>
				<TableCardRender
					loading={Loading}
					mode={ViewMode}
					className="mt-2 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3"
					table={
						<Table
							loading={Loading}
							variant="dense"
							className="mt-2 border rounded-md"
							nodes={Result.approvals.map((approval) => ({
								id: <CopyValue>APP-{approval.id}</CopyValue>,
								date: StampToDate(approval.date),
								type: <div className="capitalize">{approval.type}</div>,
								amount: `${currency} ${approval.amount}`,
								requestedBy: <InlineEmployee employee={approval.requestor} />,
								status: <ApprovalStatus status={approval.status} />,
								actions: (
									<Button onClick={() => setOpenId(approval.id)} variant="outlined" className="gap-2 btn-xs">
										<FiEye /> Open
									</Button>
								),
							}))}
							headers={[
								{ key: "id", label: "Approval ID" },
								{ key: "date", label: "Date" },
								{ key: "type", label: "Approval Type" },
								{ key: "amount", label: "Amount" },
								{ key: "requestedBy", label: "Requested By" },
								{ key: "status", label: "Status" },
								{ key: "actions", label: "Action" },
							]}
						/>
					}
					card={
						<CardsRenderer
							items={Result.approvals}
							render={(approval, i) => {
								return <Approval key={i} {...approval} onReload={() => fetchApprovals(Query, Status.value)} />;
							}}
						/>
					}
				/>
			</div>
			<ViewApproval approvalId={OpenId} onClose={() => setOpenId()} onReload={() => fetchApprovals(Query, Status.value)} />
		</>
	);
}

export default Pending;
